import { CustomerPartialStoreState, CUSTOMER_STATE_KEY } from './customer.reducer';

export const getCustomerProfile = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].profile;

export const getCustomerProfileActions = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].actions;

export const getCustomerProfileFields = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].customerFields;

export const getCustomerLoaded = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].loaded;

export const getError = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].error;

export const getIsFormSubmitted = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].isFormSubmitted;

export const getIsDeletionEmailSuccess = (state: CustomerPartialStoreState) =>
    state[CUSTOMER_STATE_KEY].isDeletionEmailSuccess;

export const getIsDeletionSuccess = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].isDeletionSuccess;

export const getPassengerPermission = (state: CustomerPartialStoreState) => {
    const profile = state[CUSTOMER_STATE_KEY].profile;

    if (profile.customer_properties) {
        const property = profile.customer_properties.find((object) => object.code === 'ONDEMAND_ATTENDANT');

        if (property.value === 'FORBIDDEN') {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
};

export const getCustomerRequestAllowed = (state: CustomerPartialStoreState) =>
    isCustomerSelfRequestAllowed(state[CUSTOMER_STATE_KEY].profile);

export const getCustomerRequestInfo = (state: CustomerPartialStoreState) =>
    getCustomerPropertyValue(state[CUSTOMER_STATE_KEY].profile, 'ONDEMAND_CUSTOMER_REQUEST_INFO');

export function isCustomerSelfRequestAllowed(
    profile:
        | {
              customer_properties?: { code: string; value?: string }[];
          }
        | null
        | undefined
): boolean {
    const value = getCustomerPropertyValue(profile, 'ONDEMAND_CUSTOMER_REQUEST_ALLOWED');
    return value.toUpperCase() !== 'N';
}

export function getCustomerPropertyValue(
    profile: { customer_properties?: { code: string; value?: string }[] } | null | undefined,
    code: string
): string {
    const property = profile?.customer_properties?.find((object) => object.code === code);
    return property?.value != null ? String(property.value).trim() : '';
}

export const getIsEmailChangeSent = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].isEmailChangeSent;

export const getIsEmailChanged = (state: CustomerPartialStoreState) => state[CUSTOMER_STATE_KEY].isEmailChanged;
